import React, { useRef, useState, useEffect } from "react"
import { useTranslation } from 'react-i18next';


import { useHookStore } from "../../../hook-store/store"
// import { resizeImageFile } from '../../utils/image/image-utils';
import { marks } from '../../../utils/marks';

import "../DiffusionOptionsDesc/DiffusionOptionsDesc.css";

import SeedInputImage from "../../../image/for-style-change/for-about/sch-input-mountain-h125.jpeg";
import SeedMaskImage from "../../../image/for-style-change/option-description/eta/mountain-mask-h100.jpeg";
import SeedStyleImage from "../../../image/for-style-change/option-description/eta/sch-style-oil-painting-h100.jpeg";
import SeedOutputImage1 from "../../../image/for-style-change/option-description/seed/mountain-output-s1-h125.jpeg";
import SeedOutputImage2 from "../../../image/for-style-change/option-description/seed/mountain-output-s3-h125.jpeg";


function StyleChangeDescSeed() {
    
    const [t] = useTranslation('translation');
  
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [hStore, hDispatch] = useHookStore();
    const { 
      // inputEta
    } = hStore.iopaintStore;

    return (
      <div className="diffsionOptionDesc">
        <div className="diffsionOptionDescRow">
          {t('diffusionOptions27', 'When images are generated by using different input value, different output images are generated, even in the condition that other input values are same.')}
          <br/>
          {t('diffusionOptions28', 'Other input values affect how different images are generated.')}
          <br/>
          {t('diffusionOptions29', 'This is useful for image variation or image output control.')}
        </div>
        <div className="diffsionOptionDescRow">
          <div className="diffsionOptionDescImages">
            <div>
              <img className="diffsionOptionDescImage"
                src={SeedInputImage}
              />
              {t('aboutPage.13', 'Input image')}
            </div>
            <div>
              <img className="diffsionOptionDescImage"
                src={SeedMaskImage}
              />
              {t('aboutStyleChange05', 'Selected part')}
            </div>
            <div>
              <img className="diffsionOptionDescImage"
                src={SeedStyleImage}
              />
              {t('aboutStyleChange06', 'Style image')}
            </div>
          </div>
        </div>
                <div className="diffsionOptionDescRow">
          <div className="diffsionOptionDescImages">
            <img className="diffsionOptionDescImage"
              src={SeedOutputImage1}
            />
            <img className="diffsionOptionDescImage"
              src={SeedOutputImage2}
            />
          </div>
        </div>
      </div>
    )
  }


export default StyleChangeDescSeed